import React from "react";
import "./styles/Help.css";

const Help = () => {
  return (
    <div className="help__con">
      <h1>How Can We help</h1>
    </div>
  );
};

export default Help;
